import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

import Scrollspy from 'react-scrollspy';

const Parts = () => {
  const headers = ['Parts'];
  
  useEffect(() => {
    
  
  }, [])
  
  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1>Parts </h1>
        <h3>Cure disease - Secure generations!</h3>
      </div>
      <section className="divider">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
              Parts 
            </div>
            <Scrollspy
              offset={-140}
              className="scrollspy" items={
                headers.map(header => {
                  return header.split(' ')[0]
                })
              }
              currentClassName="active">
              {
                headers.map(header=>{
                   
                  return (
                    <li><a href={"#"+header.split(' ')[0]}>{
                      header.replace('_', '')
                    }</a></li>
                  )
                  
                })
              }
            </Scrollspy>
            
          </div>

        </div>
        <div className="main_lab_style">
          <div style={{display:'none'}}>
          {
            headers.map(header => {
              return (
                <section href={header.split(' ')[0]}>{
                  header
                }</section>
              )

            })
          }
          </div>
          
          <div>
            <div>
              <section id="Parts">
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>Part name</p>
                      </td>
                      <td>
                        <p>Part type</p>
                      </td>
                      <td>
                        <p>Description</p>
                      </td>
                      <td>
                        <p>Designer</p>
                      </td>
                      <td>
                        <p>Length (bp)</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K4154000">BBa_K4154000</a></p>
                      </td>
                      <td>
                        <p>Coding</p>
                      </td>
                      <td>
                        <p>NsrQ_isomerase</p>
                      </td>
                      <td>
                        <p>CHAN Tsz Ki</p>
                      </td>
                      <td>
                        <p>511</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K4154001">BBa_K4154001</a></p>
                      </td>
                      <td>
                        <p>Coding</p>
                      </td>
                      <td>
                        <p>NsrO_short chain dehydrogenase/reductase</p>
                      </td>
                      <td>
                        <p>CHAN Tsz Ki</p>
                      </td>
                      <td>
                        <p>873</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K4154002">BBa_K4154002</a></p>
                      </td>
                      <td>
                        <p>Coding</p>
                      </td>
                      <td>
                        <p>NsrP_cytochrome P450 monooxygenase</p>
                      </td>
                      <td>
                        <p>CHAN Tsz Ki</p>
                      </td>
                      <td>
                        <p>1663</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K4154003">BBa_K4154003</a></p>
                      </td>
                      <td>
                        <p>Coding</p>
                      </td>
                      <td>
                        <p>AacuE_cytochrome P450 monooxygenase</p>
                      </td>
                      <td>
                        <p>CHAN Tsz Ki</p>
                      </td>
                      <td>
                        <p>1616</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K4154004">BBa_K4154004</a></p>
                      </td>
                      <td>
                        <p>Coding</p>
                      </td>
                      <td>
                        <p>AacuF_short chain dehydrogenase/reductase</p>
                      </td>
                      <td>
                        <p>CHAN Tsz Ki</p>
                      </td>
                      <td>
                        <p>801</p>
                      </td>
                    </tr>
                    
                    <tr>
                      <td>
                        <p><a target="_blank" href="http://parts.igem.org/Part:BBa_K4154006">BBa_K4154006</a></p>
                      </td>
                      <td>
                        <p>Composite</p>
                      </td>
                      <td>
                        <p>PamyB-nsrQO+AacuE-TamyB</p>
                      </td>
                      <td>
                        <p>CHAN Tsz Ki</p>
                      </td>
                      <td>
                        <p>3897</p>
                      </td>
                    </tr>
                    
                  </tbody>
                </table>
              </section>
            </div>
            
          </div>
        </div>
      </section>
    </div>
  );
}

export default Parts;
